var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSignOut = function SvgSignOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.778 16q-.734 0-1.256-.522A1.71 1.71 0 0 1 0 14.222V1.778Q0 1.044.522.522A1.71 1.71 0 0 1 1.778 0H8v1.778H1.778v12.444H8V16zm9.778-3.556-1.223-1.288L12.6 8.889H5.333V7.11H12.6l-2.267-2.267 1.223-1.288L16 8z"
  })));
};
export default SvgSignOut;